<template>
  <p-row
    justify-center
    align-end
    :class="classList"
  >
    <p-button
      :disabled="disabled"
      :readonly="readonly"
      icon
      @click="changePage(-1)"
    >
      <p-icon :dense="!spacious">
        navigate_before
      </p-icon>
    </p-button>
    <p-text-field
      :value="display"
      :disabled="disabled"
      :readonly="readonly"
      label=""
      solo
      :class="textFieldSize"
      @keyup.enter="setPageIfValid($event.target.value)"
      @blur="setPageIfValid($event.target.value)"
    ></p-text-field>
    <p-button
      :disabled="disabled"
      :readonly="readonly"
      icon
      @click="changePage(1) "
    >
      <p-icon :dense="!spacious">
        navigate_next
      </p-icon>
    </p-button>
    <p-select
      v-if="!noPagingSize"
      v-model="value.pageSize"
      solo
      label=""
      class="ix-3"
      :items="pageSizeItems"
      :disabled="disabled"
      :readonly="readonly"
      @input="setPageSize"
    ></p-select>
  </p-row>
</template>

<script lang="ts">
  import interactable from '../../mixins/interactable/interactable';
  import sizeable from '../../mixins/sizeable/sizeable';
  import inputable from '../../mixins/inputable/inputable';
  import mixins from '../../mixins';
  import ResponsePagingInfo from '../../plugins/servicelayer/responseTypes/responsePagingInfo';
  // eslint-disable-next-line no-unused-vars

  export default mixins(interactable, sizeable, inputable).extend({
    mixins: [inputable, interactable, sizeable],
    props: {
      value: { default: () => ({}), type: Object },
      noPagingSize: { default: false, type: Boolean },
    },
    data: () => ({
    }),
    watch: {
      'value.totalPages': {
        handler() {
          this.setPage(this.value?.currentPage);
        },
      },
      'value.totalCount': {
        handler() {
          this.setPage(this.value?.currentPage);
        },
      },
      'value.pageSize': {
        handler() {
          this.setPage(this.value?.currentPage);
        },
      },
    },
    computed: {
      pageSizeItems() {
        const pageSizes = [
          { id: 10, caption: '10' },
          { id: 15, caption: '15' },
          { id: 25, caption: '25' },
          { id: 50, caption: '50' },
          { id: 100, caption: '100' },
        ];
        if (this.value?.pageSize && !pageSizes.find((i) => i.id === this.value?.pageSize)) {
          pageSizes.push({ id: this.value.pageSize, caption: this.value.pageSize.toString() });
        }
        pageSizes.sort((a, b) => a.id - b.id);
        return pageSizes;
      },
      classList() {
        return {
          'p-pagination': true,
        };
      },
      textFieldSize() {
        if (this.spacious) {
          return 'ix-4';
        }
        if (this.dense) {
          return 'ix-2';
        }
        return 'ix-3';
      },
      display(): string {
        const paging = (this.value as ResponsePagingInfo);
        let currentPage = paging.currentPage ?? 1;
        if (Number.isNaN(currentPage)) {
          currentPage = 1;
        }
        return `${currentPage}/${this.getTotalPages(this.value)}`;
      },
    },
    methods: {
      getTotalPages(paging: ResponsePagingInfo) {
        if (paging.totalPages && (!paging.totalCount || !paging.pageSize)) {
          return paging.totalPages;
        }
        const pageSize = Math.max(1, paging.pageSize);
        const totalEntries = Math.max(1, paging.totalCount);
        let rounded = Math.ceil(totalEntries / pageSize);
        rounded = Number.isNaN(rounded) ? 1 : rounded;
        return rounded;
      },
      changePage(offset: number) {
        const newPage = this.value.currentPage + offset;
        this.setPage(newPage);
      },
      clampToPageSize(page: number | undefined | null): number {
        let newPage = page ?? 1;
        newPage = Math.min(this.getTotalPages(this.value), newPage);
        newPage = Math.max(1, newPage);
        return newPage;
      },
      setPageIfValid(pageString: string) {
        if (Number.isInteger(Number(pageString))) {
          this.setPage(Number(pageString));
        }
      },
      setPage(page: number) {
        const newPage = this.clampToPageSize(page);
        if (newPage === this.value.currentPage) {
          return;
        }
        this.onInput({ ...this.value, currentPage: newPage });
      },
      setPageSize(pageSize: number) {
        this.onInput({ ...this.value, pageSize });
      },
    },
  });
</script>
